// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"737":"c57a20c9","2457":"c57a20c9","2648":"c57a20c9","4654":"f3f55365","5345":"f3f55365","6930":"31d6cfe0","8017":"31d6cfe0","8529":"5f9f3443"}[chunkId] + ".chunk.css";
};